import React, { useEffect, useState } from "react";

import { Card, Col, Form, Row } from "react-bootstrap";
import Progress from "react-progress-2";
import { toast } from "react-hot-toast";
import EditButton from "../../components/common/EditButton";
import ViewButton from "../../components/common/ViewButton";
import DeleteButton from "../../components/common/DeleteButton";
import CardHeader from "../../components/common/CardHeader";
import LinkButton from "../../components/common/LinkButton";
import CardBody from "../../components/common/CardBody";
import ProductImage from "../../components/common/ProductImage";
import CheckPermission from "../../components/roles/CheckPermission";
import { privateApi } from "../../api";

const CategoryList = () => {
      const [categories, setCategories] = useState([]);
      const [loading, setLoading] = useState(false);
      const [totalItems, setTotalItems] = useState(0);
      const [perPages, setPerPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(0);

      const [limit, setLimit] = useState(10);
      const [search, setSearch] = useState("");

      const loadData = async () => {
            setLoading(true);
            await privateApi
                  .get(`/dashboard/categories?limit=${limit}&search=${search}`)
                  .then((response) => {
                        setCategories(response.data.categories);
                        setTotalItems(response.data.totalItems);
                        setPerPages(response.data.itemsCountPerPage);
                        setCurrentPage(response.data.currentPage);
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      useEffect(() => {
            loadData();
      }, [limit, search]);

      async function getData(pageNumber = 1) {
            window.scrollTo(0, 0);
            setLoading(true);
            Progress.show();
            const url = `/dashboard/categories?page=${pageNumber}&limit=${limit}&search=${search}`;
            await privateApi(url)
                  .then((response) => {
                        setCategories(response.data.categories);
                        setTotalItems(response.data.totalItems);
                        setPerPages(response.data.itemsCountPerPage);
                        setCurrentPage(response.data.currentPage);
                        Progress.hide();
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      }

      const handleStatus = async (category) => {
            await privateApi
                  .post(`/dashboard/categories/${category.slug}/status`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              toast.success(response.data.message);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };

      const handleMenu = async (category) => {
            await privateApi
                  .post(`/dashboard/categories/${category.slug}/menu`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              toast.success(response.data.message);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };

      const handleDelete = async (category) => {
            const response = await privateApi
                  .delete(`/dashboard/categories/${category.slug}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setCategories((categories) =>
                                    categories.filter(
                                          (item) => item.id !== category.id
                                    )
                              );
                              loadData();
                              toast.success(response.data.message);
                              return true;
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            return response;
      };

      return (
            <>
                  <Row>
                        <Col lg={12}>
                              <Card>
                                    <CardHeader title="Category List">
                                          <LinkButton
                                                link="/dashboard/categories/create"
                                                title="Add New"
                                          />
                                          <LinkButton
                                                link="/dashboard/categories/manage/order"
                                                title="Manage Order"
                                          />
                                          <LinkButton
                                                link="/dashboard/categories/home/order"
                                                title="Home Order"
                                          />
                                    </CardHeader>
                                    <CardBody
                                          setLimit={setLimit}
                                          setSearch={setSearch}
                                          totalItems={totalItems}
                                          perPages={perPages}
                                          currentPage={currentPage}
                                          getData={getData}
                                    >
                                          <thead>
                                                <tr>
                                                      <th>#</th>
                                                      <th>Name</th>
                                                      <th>Category</th>
                                                      <th>Products</th>
                                                      <th width="120px">
                                                            Menu
                                                      </th>
                                                      <th width="120px">
                                                            Home
                                                      </th>
                                                      <th width="80px">
                                                            Status
                                                      </th>
                                                      <th width="120px">
                                                            Action
                                                      </th>
                                                </tr>
                                          </thead>
                                          <tbody>
                                                {!loading ? (
                                                      categories?.length > 0 ? (
                                                            categories.map(
                                                                  (
                                                                        category,
                                                                        index
                                                                  ) => (
                                                                        <>
                                                                              <tr
                                                                                    key={
                                                                                          index
                                                                                    }
                                                                              >
                                                                                    <td className="text-center">
                                                                                          {
                                                                                                ++index
                                                                                          }
                                                                                    </td>
                                                                                    <td>
                                                                                          <ProductImage
                                                                                                title={
                                                                                                      category.title
                                                                                                }
                                                                                                image={
                                                                                                      category.image
                                                                                                }
                                                                                                icon={
                                                                                                      category?.icon
                                                                                                }
                                                                                                category={`Subtitle: ${
                                                                                                      category.subtitle ||
                                                                                                      ""
                                                                                                }`}
                                                                                          />
                                                                                    </td>
                                                                                    <td>
                                                                                          <ProductImage
                                                                                                title={
                                                                                                      category.sub_category
                                                                                                }
                                                                                                category={` ${
                                                                                                      category.parent_category
                                                                                                            ? "Parent: " +
                                                                                                              category.parent_category
                                                                                                            : ""
                                                                                                }`}
                                                                                          />
                                                                                    </td>
                                                                                    <td>
                                                                                          {
                                                                                                category.products
                                                                                          }
                                                                                    </td>
                                                                                    <td className="text-center">
                                                                                          <Form.Check
                                                                                                type="switch"
                                                                                                id="custom-switch1"
                                                                                                defaultChecked={
                                                                                                      category.navigation_status ===
                                                                                                      1
                                                                                                            ? true
                                                                                                            : false
                                                                                                }
                                                                                                onClick={() =>
                                                                                                      handleMenu(
                                                                                                            category
                                                                                                      )
                                                                                                }
                                                                                          />
                                                                                    </td>
                                                                                    <td className="text-center">
                                                                                          <Form.Check
                                                                                                type="switch"
                                                                                                id="custom-switch1"
                                                                                                defaultChecked={
                                                                                                      category.home_status ===
                                                                                                      1
                                                                                                            ? true
                                                                                                            : false
                                                                                                }
                                                                                                onClick={() =>
                                                                                                      handleMenu(
                                                                                                            category
                                                                                                      )
                                                                                                }
                                                                                          />
                                                                                    </td>
                                                                                    <td>
                                                                                          <Form.Check
                                                                                                type="switch"
                                                                                                id="custom-switch"
                                                                                                defaultChecked={
                                                                                                      category.status ==
                                                                                                      1
                                                                                                            ? true
                                                                                                            : false
                                                                                                }
                                                                                                onBlur={() =>
                                                                                                      handleStatus(
                                                                                                            category
                                                                                                      )
                                                                                                }
                                                                                          />
                                                                                    </td>
                                                                                    <td className="text-center">
                                                                                          <EditButton
                                                                                                link={`/dashboard/categories/${category.slug}/edit`}
                                                                                          />
                                                                                          <ViewButton
                                                                                                link={`/dashboard/categories/${category.slug}/show`}
                                                                                          />
                                                                                          <CheckPermission permission="category-delete">
                                                                                                <DeleteButton
                                                                                                      item={
                                                                                                            category
                                                                                                      }
                                                                                                      loading={
                                                                                                            loading
                                                                                                      }
                                                                                                      setLoading={
                                                                                                            setLoading
                                                                                                      }
                                                                                                      handleDelete={
                                                                                                            handleDelete
                                                                                                      }
                                                                                                />
                                                                                          </CheckPermission>
                                                                                    </td>
                                                                              </tr>
                                                                        </>
                                                                  )
                                                            )
                                                      ) : (
                                                            <>
                                                                  <tr>
                                                                        <td
                                                                              colSpan={
                                                                                    9
                                                                              }
                                                                              className="text-center"
                                                                        >
                                                                              No
                                                                              Category
                                                                              Found
                                                                        </td>
                                                                  </tr>
                                                            </>
                                                      )
                                                ) : (
                                                      <>
                                                            <tr>
                                                                  <td
                                                                        colSpan={
                                                                              9
                                                                        }
                                                                        className="text-center"
                                                                  >
                                                                        Loading...
                                                                  </td>
                                                            </tr>
                                                      </>
                                                )}
                                          </tbody>
                                    </CardBody>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default CategoryList;
